module.exports = __webpack_public_path__ + "img/microplastics-process-8-mobile.f52d9fb1.png";